<!-- @component `Block`
Functions as a layout for components of an <Article>. -->
<script lang="ts">
	import type { ContainerWidth } from '$types/ContainerWidth';

	/** Width of the block within the article well. */
	export let width: ContainerWidth = 'normal';

	/** Add an id to the block tag to target it with custom CSS. */
	export let id: string = '';
	/** Add extra classes to the block tag to target it with custom CSS. */
	export let cls: string = '';

	/** ARIA [role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles) for the block */
	export let role: string | null = null;

	/** ARIA [label](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-label) for the block */
	export let ariaLabel: string | null = null;
</script>

<div {id} class="block {width} {cls}" {role} aria-label="{ariaLabel}">
	<!-- block content -->
	<slot {width} />
</div>

<style lang="scss">
	div.block {
		margin-top: 0;
		margin-right: auto;
		margin-left: auto;
		padding-right: 12px;
		padding-bottom: 32px;
		padding-left: 12px;
		max-width: var(--normal-column-width, 700px);

		&.narrow {
			max-width: var(--narrow-column-width, 500px);
		}

		&.wide {
			max-width: var(--wide-column-width, 900px);
		}

		&.full-width {
			padding-right: 0;
			padding-left: 0;
			max-width: 100%;
		}

		&.fluid {
			margin-left: -15px;
			padding-right: 0;
			padding-left: 0;
			width: calc(100% + 30px);
			max-width: none;
		}
	}
</style>
